import { render } from "./SideNavigation.vue?vue&type=template&id=4f703f38&ts=true&lang=pug"
import script from "./SideNavigation.vue?vue&type=script&lang=ts"
export * from "./SideNavigation.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__